module.exports = "/_next/static/images/Aggregation-5341b10b62bfd28e333ae3e10527056c.webp";